import { KeyedMutator } from "swr";

import { API_URL } from "constants/api";
import { useSwr } from "hooks/useSwr";

const useGetUserInfo = (): {
  userInfo: User;
  error: Error;
  mutate: KeyedMutator<User>;
  isLoading?: boolean;
} => {
  const { data, error, mutate, isLoading } = useSwr<User>(`${API_URL}/user`, {
    revalidateIfStale: true,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  });

  return { userInfo: data, error, mutate, isLoading };
};

export default useGetUserInfo;
